// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const IndiaExportsTable: MarkdocTagRegistration = {
  tag: 'india-exports-table',
  component: 'IndiaExportsTable',
  attributes: {
    entries: {
      type: Array,
      default: [],
      required: true,
    },
  },
};
